<template>
    <div id="catalog">
        <headers :title='titles'></headers>
        <div class="content">
            <p class="prompting">视频只有开通的学生可以观看<i></i></p>
            <div class="list-wrap">
                <dl class="list"
                    v-for="item in list">
                    <dt>{{item.name}}</dt>
                    <dd v-for="d in item.list">
                        <i @click="playVideo(d.video_url)"
                           class="icon-bofang3"></i>
                        <p>{{d.name}}</p>
                        <i @click="selected(d)"
                           :class="{'icon-fangxingkuang':!d.active,'icon-fangxing':d.active}">
                            <div v-if='d.active'>移除</div>
                            <div v-else>加入</div>
                        </i>
                    </dd>
                </dl>
            </div>
        </div>
        <div class="foot">
            <div class="bottom_btn">
                <a>
                    <i></i>
                    <span class="1"
                          v-if='qid.length'>已选( {{qid.length}} )</span>
                    <span v-else>已选(0)</span>
                </a>
                <a v-if='qid.length'
                   @click="send"
                   class="a">去发布</a>
                <a v-else
                   class="b">去发布</a>
            </div>
        </div>
        <videoPlayer v-if="!inApp"
                     ref="videoPlayer"
                     @closePlayer="closePlayer"
                     v-show="playFlag"
                     :video_url="videoUrl"
                     submit="1"></videoPlayer>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue'
import videoPlayer from 'SRC/components/base/videoPlayer.vue';  // 视频播放弹窗
export default {
    data () {
        return {
            closeFlag: true,
            list: [],
            titles: '知识点视频',
            qid: [],  //所选的列表的id
            is_active: Number(this.$route.query.is_active) || 0, //是否来自寒假活动
        }
    },
    created () {
        // 设置返回
        let math_send_ok = localStorage.getItem('math_send_ok');
        if (math_send_ok == 1) {
            this.$router.go(-1);
            return false;
        }
        let cid = this.$store.state.math.knowledgeid.join(',')
        this.$http.post(API_URL_TASK_API + '/maths/send/video/knowledge', { cid: cid }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.list = this.list.concat(res.data);
                this.list.forEach(function (item) {
                    item.list.forEach(d => {
                        d.active = false;
                    })
                });
                this.$nextTick(function () {
                    MathJax.Hub.Typeset(document.body);
                })
            }
        })
    },
    components: {
        headers,
        videoPlayer
    },
    computed: {},
    destroyed () {

    },
    methods: {
        goBack () {
            this.$router.go(-1)
        },
        close () {
            this.closeFlag = false;
        },
        // 发布视频 
        send () {

            this.$store.commit('setKnowledgedata', this.qid)
            if (this.is_active) { //是否来自寒假活动
                this.$router.push('/sx/release/21/1?is_active=2&type=1')
            } else {
                this.$router.push('/sx/release/21/6')
            }

        },
        open (arg) {
            // try {
            //   appobject.Interactive('ys_video,' + arg);
            // } catch (e) {
            //   layer.open({
            //     title:'提示',
            //     content: '请下载同步课堂客户端，体验更多功能！<br />下载地址：http://m.tbkt.cn',
            //     btn: '确定',
            //     yes: function () {
            //       layer.closeAll();
            //     }
            //   });
            // }
            if (this.inApp) {
                this.appFunction("ys_video", arg);
            } else {
                this.videoUrl = arg;
                this.playFlag = true;
                this.$nextTick(() => {
                    this.$refs.videoPlayer.play();
                })
            }
        },

        selected (d) {
            if (!d.active) {
                if (this.qid.length < 10) {
                    let obj = {}
                    obj.kid = d.id
                    obj.cid = d.catalog_id
                    this.qid.push(obj)
                } else {
                    layer.tips('已经超出10道题,不能再添加试题了')
                    return false
                }
            } else {
                if (this.qid.length > 0) {
                    this.qid.forEach((m, n) => {
                        if (m.kid == d.id) {
                            this.qid.splice(n, 1)
                        }
                    })
                }
            }
            d.active = !d.active;
            this.list.splice(0, 1, this.list[0]);
        },
        playVideo (url) {
            if (this.inApp) {
                this.appFunction("ys_video", `${url},1`);
            } else {
                this.videoUrl = url;
                this.playFlag = true;
                this.$nextTick(() => {
                    this.$refs.videoPlayer.play();
                })
            }
        },
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#catalog {
    min-height: 100vh;
    .content {
        .prompting {
            position: relative;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 30px / $ppr;
            color: #5e89ef;
            text-align: center;
            background-color: #fff;
            i {
                display: block;
                position: absolute;
                top: 36px / $ppr;
                right: 40px / $ppr;
                color: #cbcbcb;
            }
        }

        .list-wrap {
            margin-bottom: 120px / $ppr;
            .list {
                margin-top: 32px / $ppr;
                background-color: #fff;
                dt {
                    padding-left: 32px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    font-weight: bold;
                    color: #333;
                }
                dd {
                    position: relative;
                    padding-left: 32px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 28px / $ppr;
                    color: #333;
                    border-top: 1px / $ppr solid #e8e8e8;
                    i {
                        display: inline-block;
                        position: absolute;
                        top: 20px / $ppr;
                        font-size: 40px / $ppr;
                        &.icon-bofang3 {
                            left: 32px / $ppr;
                            color: #21bf63;
                            display: inline-block;
                            width: 50px / $ppr;
                            height: 50px / $ppr;
                            background: url("./img/icon_video.png");
                            background-size: 100% 100%;
                        }
                        &.icon-fangxingkuang {
                            top: 20px / $ppr;
                            text-align: center;
                            line-height: 50px / $ppr;
                            width: 122px / $ppr;
                            height: 48px / $ppr;
                            right: 32px / $ppr;
                            border: 1px / $ppr solid #5e89ef;
                            color: #5e89ef;
                            border-radius: 50px / $ppr;
                            font-size: 24px / $ppr;
                            box-sizing: border-box;
                        }
                        &.icon-fangxing {
                            top: 20px / $ppr;
                            text-align: center;
                            line-height: 50px / $ppr;
                            width: 122px / $ppr;
                            height: 48px / $ppr;
                            right: 32px / $ppr;
                            border: 1px / $ppr solid #ff6600;
                            color: #ff6600;
                            border-radius: 50px / $ppr;
                            font-size: 24px / $ppr;
                            box-sizing: border-box;
                        }
                        div {
                            line-height: 48px / $ppr;
                        }
                    }
                    p {
                        padding-left: 74px / $ppr;
                        width: 400px / $ppr;
                        font-size: 30px / $ppr;
                        color: #555;
                        line-height: 96px / $ppr;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
    .foot {
        position: fixed;
        bottom: 0;
        width: 100%;
        .bottom_btn {
            a {
                display: inline-block;
                height: 96px / $ppr;
                line-height: 96px / $ppr;
                width: 100%;
                color: #333;
                background-color: $c-theme;
                text-align: center;
                font-size: 30px / $ppr;
                color: #fff;
                float: left;
                box-sizing: border-box;
                &.a {
                    background-color: $c-theme;
                }
                &.b {
                    background-color: #999999;
                }
            }
            a:nth-of-type(1) {
                background: #f0f0f0;
                width: 60%;
                color: black;
            }
            a:nth-of-type(2) {
                width: 40%;
            }
            i {
                display: inline-block;
                width: 80px / $ppr;
                height: 50px / $ppr;
                position: relative;
                top: 13px / $ppr;
                background: url("./img/icon1.png");
                background-repeat: no-repeat;
                background-size: contain;
            }
        }
    }
}
</style>
